export default __webpack_public_path__ + "static/brand-logo-deree-1fd3eaeefe159c65eba5dc412534b225.png";